export class VwoCampaignClass {
  constructor (campaignKey, variant, uuid) {
    this.campaignKey = campaignKey
    this.variant = variant
    this.uuid = uuid
  }
}

export const state = () => ({
  campaigns: [],
  multistoreSession: null
})

export const mutations = {
  ADD_CAMPAIGN (state, { getters, campaign }) {
    if (!(campaign instanceof VwoCampaignClass)) {
      this.$bugsnag.notify('Invalid VwoCampaign object', campaign)
      return
    }

    if (getters.getCampaign(campaign.campaignKey, campaign.uuid)) {
      this.$bugsnag.notify('Campaign Already exists', campaign)
      return
    }

    state.campaigns.push(campaign)
  },

  SET_MULTISTORE_SESSION (state, session) {
    state.multistoreSession = session
  }
}

export const actions = {
  ADD_CAMPAIGN: ({ commit, getters }, campaign) => {
    commit('ADD_CAMPAIGN', { getters, campaign })
  },

  saveMultistoreSession ({ commit }, { variant, isMultistoreResponse, searchId }) {
    const data = {
      variant,
      isMultistoreResponse,
      searchId,
      timestamp: new Date().getTime()
    }
    commit('SET_MULTISTORE_SESSION', data)
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('multistore_pwa_session', JSON.stringify(data))
    }
  },

  loadMultistoreSession ({ commit }) {
    if (typeof sessionStorage === 'undefined') return

    const data = sessionStorage.getItem('multistore_pwa_session')
    if (!data) {
      return
    }

    try {
      const parsed = JSON.parse(data)
      const now = new Date().getTime()
      const expiryMs = 15 * 60 * 1000 // 15 minutes

      if (now - parsed.timestamp > expiryMs) {
        sessionStorage.removeItem('multistore_pwa_session')
        commit('SET_MULTISTORE_SESSION', null)
      } else {
        commit('SET_MULTISTORE_SESSION', parsed)
      }
    } catch (e) {
      commit('SET_MULTISTORE_SESSION', null)
    }
  },

  clearMultistoreSession ({ commit }) {
    commit('SET_MULTISTORE_SESSION', null)
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem('multistore_pwa_session')
    }
  }
}

export const getters = {
  getCampaigns: state => state.campaigns,

  getCampaign: state => (campaignKey, uuid) => {
    return state.campaigns.find(arrayItem =>
      arrayItem?.campaignKey?.toLowerCase() === campaignKey.toLowerCase() && arrayItem.uuid === uuid
    )
  },

  getMultistoreSession: state => state.multistoreSession
}
